type Model = 'user_investment_accounts' | 'provider_contract_types' | 'users';

export default function createIriFromId(model: Model, id: string, version: 'v1' | 'v2' = 'v1'): string {
  return `/${ version }/${ model }/${ id }`;
}
